import { Pipe } from "@angular/core";

@Pipe({
    name: "authorizationMethod",
    standalone: false
})
export class AuthorizationMethodPipe {
    transform(id: number | null): string {
        switch (id) {
            case null: return "--"
            case 0: return "RO Authorized"
            case 1: return "Forward to WO"
            case 2: return "Split RO/WO Authorization"
            case 3: return "WO Authorized"
            case 4: return "Not Authorized"
            default: return id?.toString();
        }
    }
}